var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 8.01127C0.5 4.06034 3.6575 0.5 8.015 0.5C12.275 0.5 15.5 3.99274 15.5 7.98873C15.5 12.6232 11.72 15.5 8 15.5C6.77 15.5 5.405 15.1695 4.31 14.5235C3.9275 14.2907 3.605 14.1179 3.1925 14.2531L1.6775 14.7038C1.295 14.824 0.95 14.5235 1.0625 14.1179L1.565 12.4354C1.6475 12.2026 1.6325 11.9547 1.5125 11.7594C0.8675 10.5726 0.5 9.27316 0.5 8.01127ZM7.02491 8.01127C7.02491 8.54457 7.45241 8.97271 7.98491 8.98022C8.51741 8.98022 8.94491 8.54457 8.94491 8.01878C8.94491 7.48548 8.51741 7.05734 7.98491 7.05734C7.45991 7.04983 7.02491 7.48548 7.02491 8.01127ZM10.4825 8.01878C10.4825 8.54457 10.91 8.98022 11.4425 8.98022C11.975 8.98022 12.4025 8.54457 12.4025 8.01878C12.4025 7.48548 11.975 7.05734 11.4425 7.05734C10.91 7.05734 10.4825 7.48548 10.4825 8.01878ZM4.52758 8.98023C4.00258 8.98023 3.56758 8.54457 3.56758 8.01879C3.56758 7.48549 3.99508 7.05734 4.52758 7.05734C5.06008 7.05734 5.48758 7.48549 5.48758 8.01879C5.48758 8.54457 5.06008 8.97272 4.52758 8.98023Z",
    fill: "#A6ABC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.202cd1b4513faf1e2db49fa35c8063e9.svg";
export { ForwardRef as ReactComponent };